import {Component, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { IGenomeTime } from 'bz-genome-angular/time-picker/time-picker/bzg-time-picker.component';
import { GenomeTimeService } from 'app/shared/services/genome-time.service';
import { EJobType } from '../job-type.enum';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { UserJobsService } from 'app/scheduler/user-Jobs/user-jobs.service';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { IJob } from '../IJob';

@Component({
    selector: 'job-settings',
    templateUrl: 'job-settings.component.html',
    styleUrls: ['job-settings.component.scss']
})
export class JobSettingsComponent {

    @Input() applyDisabled = false;
    @Input() currentJob: IJob;
    @Input() jobType: EJobType;
    @Output() saveJob = new EventEmitter<IJob>();
    @Output() cancel = new EventEmitter();
    @Output() reset = new EventEmitter();

    public showReset: boolean = false;
    public nextRuntimeDate: Date;
    public nextRuntimeDateTime: IGenomeTime;

    @ViewChild('dpTo', { static: false}) dpTo: any;

    constructor(private _genomeTimeService: GenomeTimeService,
                private _modalService: BzgModalService,
                private _userJobService: UserJobsService,
                private _toastService: BzgToastService,
                private _translateService: TranslateService,
                private _i18nService: I18nService) {
        this.nextRuntimeDateTime = {
            hours: 12,
            minutes: 0,
            seconds: 0,
            period: 'AM'
        };
    }

    ngOnChanges() {
        this.nextRuntimeDate = new Date(this.currentJob.nextRuntime);
        this.nextRuntimeDateTime = this._genomeTimeService.getTimeFromDate(this.nextRuntimeDate);
        if(this.currentJob.disableEditJob && this.dpTo && this.dpTo.onShown) {
            this.dpTo.onShown.isStopped = true;
        }
        if (this.currentJob)
          this.getStatusReset();
    }

    public setJobNow() {
        const now : Date = new Date();
        this.currentJob.nextRuntime = now;
        this.currentJob.enabled = true;
        this.nextRuntimeDate = now;
        this.nextRuntimeDateTime = this._genomeTimeService.getTimeFromDate(this.nextRuntimeDate);
    }

    public applyChanges() {
        this._genomeTimeService.setTimeToDate(this.nextRuntimeDate, this.nextRuntimeDateTime);
        this.currentJob.nextRuntime = this.nextRuntimeDate;
        this.saveJob.emit(this.currentJob);
        this.getStatusReset();
    }

    public cancelChanges() {
        this._genomeTimeService.setTimeToDate(this.nextRuntimeDate, this.nextRuntimeDateTime);
        this.currentJob.nextRuntime = this.nextRuntimeDate;
        this.cancel.emit();
    }

    public isUserJob() {
        return this.jobType === EJobType.User;
    }

    public resetJob() {
      const title = `${this._i18nService.instant('GLOBAL.RESET')} - ${this.currentJob.name}`
      const modal = this._modalService.open(DeleteConfirmationComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: { title, message: 'GLOBAL.CONFIRM_RESET', button: 'GLOBAL.RESET' }
      });
      modal.afterClosed().subscribe((result) => {
          if (result === 'delete') {
            this._userJobService.resetStatus(this.currentJob.guid).subscribe((response) => {
              if (response)
                this.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success', 5000);
            });
          }
      });
    }

    public getStatusReset() {
      if (this.currentJob.guid) {
        this._userJobService.getStatusReset(this.currentJob.guid).subscribe((response) => {
          this.showReset = response;
        });
      }
    }

    showToast(messageInput: string, type: BzgToastType, duration: number) {
      this.reset.emit();
      this.getStatusReset();
      this._toastService.open(
        messageInput,
        {
          type,
          duration: duration,
          verticalPosition: 'bottom',
          horizontalPosition: 'right'
      });
    }
}
